import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import v from "./iconfont.es5471.js";
const h = {
  display: "block"
}, x = ({ size: t = 16, useVw: n, useRem: o, color: c, withColor: i, removeClassName: e, disableSSR: p, style: l, ...d }) => {
  const m = l ? { ...h, ...l } : h;
  return /* @__PURE__ */ a.createElement(v, { disableSSR: p }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-panqianjiaoyi", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (o ? "rem" : "px"), height: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (o ? "rem" : "px"), className: e ? "" : "iconpark-icon", style: m, fill: "none", ...d }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: e ? "" : "32px-çåäº¤æ"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: e ? "" : "normal",
        fill: i ? r(c, 0, "#262933") : "#262933",
        datafollowfill: i ? r(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M21.73 4.3a.9.9 0 0 1 .9.9v1.6h1.5a3.77 3.77 0 0 1 3.77 3.77v13.26a3.77 3.77 0 0 1-3.77 3.77H7.87a3.77 3.77 0 0 1-3.77-3.77v-2.38a.9.9 0 1 1 1.8 0v2.38a1.97 1.97 0 0 0 1.97 1.97h16.26a1.97 1.97 0 0 0 1.97-1.97V10.57a1.97 1.97 0 0 0-1.97-1.97h-1.5v1.6a.9.9 0 0 1-1.8 0V8.6h-9.66v1.6a.9.9 0 1 1-1.8 0V8.6h-1.5a1.97 1.97 0 0 0-1.97 1.97v3.706c0 .56.454 1.013 1.013 1.013h8.567l-1.5-1.286a.9.9 0 1 1 1.171-1.367l2.366 2.028c.972.833.383 2.425-.897 2.425H6.913A2.813 2.813 0 0 1 4.1 14.276v-3.707A3.77 3.77 0 0 1 7.87 6.8h1.5V5.2a.9.9 0 1 1 1.8 0v1.6h9.66V5.2a.9.9 0 0 1 .9-.9Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M14.422 19.115c-1.28 0-1.869 1.592-.897 2.425l2.366 2.028a.9.9 0 1 0 1.171-1.367l-1.5-1.286h7.132a.9.9 0 1 0 0-1.8h-8.272Z"
        }
      )
    )
  )));
}, s = x;
export {
  s as default
};
